import { createStyles } from 'antd-style';
export var useStyles = createStyles(function (_ref) {
  var token = _ref.token;
  return {
    // 主容器
    container: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      height: 48,
      lineHeight: '48px',
      backgroundColor: token.colorPrimary,
      padding: '0 16px 0 24px'
    },
    // > 左侧图标区
    containerLeft: {
      display: 'flex',
      alignItems: 'center',
      color: '#FFFFFF',
      fontSize: '14px',
      fontWeight: 500,
      '& > img': {
        height: '32px',
        maxWidth: '72px',
        marginRight: '8px',
        objectFit: 'contain'
      },
      '& > span': {
        fontSize: '14px'
      }
    },
    // > 中部搜索框区
    containerCenter: {
      backgroundColor: token.colorPrimaryBg,
      transition: 'background-color 400ms linear',
      borderRadius: '2px',
      position: 'absolute',
      top: '8px',
      left: 'calc(50% - 200px)',
      width: '400px'
    },
    // > 右侧头像区
    containerRight: {
      '&, & .ant-dropdown-trigger': {
        display: 'flex',
        alignItems: 'center'
      },
      '& .ant-dropdown-trigger': {
        color: 'white',
        gap: 6
      }
    },
    // > > 选择器
    containerTopRightSelector: {
      '& > .ant-select-selector': {
        color: 'white !important',
        border: 'unset !important',
        boxShadow: 'unset !important',
        backgroundColor: 'transparent !important'
      },
      '&.ant-select-open > .ant-select-selector': {
        backgroundColor: 'rgba(0, 0, 0, 0.06) !important',
        '& .ant-select-selection-item': {
          color: 'white !important'
        }
      },
      '& > .ant-select-selector:hover': {
        backgroundColor: "rgba(0, 0, 0, 0.06) !important"
      },
      '& > .ant-select-arrow': {
        color: 'white !important'
      }
    },
    // > > 头像
    containerTopRightAvatar: {
      '& > .ant-pro-sider-actions-avatar': {
        paddingBlock: '0 !important',
        height: '32px !important'
      }
    }
  };
});